import {Injectable} from '@angular/core';
import {FeedbackData} from '../models/feedback-data';

@Injectable({
  providedIn: 'root'
})
export class FeedbackDataService {

public feedbackData!:FeedbackData|null;
}
